// The section's DOM id, URL hash, and accordion value. The facesheet's risk
// chip links to it, so it lives apart from the component both sides can import.
export const RISK_CONTRIBUTORS_ANCHOR = 'risk-contributors'
